/** 
 * 全局组件
 * 自动遍历所有base目录下组件引入，需按照nfButton目录结构编写 
 */

let requireContext = require.context('./', true, /.+\/.+\/.+\.js$/)
let modules = {}
let reg = /\.\/(.+)\//i
requireContext.keys().forEach(key => {
    let name = key.match(reg)[1]
    modules[name] = requireContext(key).default
})

export default modules